export const dashboardData = {
  user: {
    name: 'John Davis',
    role: 'Team Lead',
    avatarUrl: 'https://i.pravatar.cc/150?u=johndavis',
    currentMonth: 'May 2025',
  },
  kpis: {
    totalPointsMtd: 6000,
    teamGoal: 30000,
    percentOfGoal: 20.0,
    speedBonusEarned: 1500,
  },
  teamGoalDetails: {
    losOnTeam: 3,
    goalPerLo: 10000,
    newLosNotCounted: 1,
    remainingPoints: 24000,
  },
  teamPerformance: {
    creditPulls: { points: 2250, perUnit: 750, los: 3 },
    docOuts: { points: 1500, perUnit: 500, los: 3 },
    submissions: { points: 1500, perUnit: 500, los: 3 },
    closings: { points: 750, perUnit: 250, los: 3 },
  },
  loBreakdown: [
    {
      id: '1',
      name: 'Sarah Chen',
      initials: 'SC',
      creditPulls: { count: 800, points: 1200 },
      docOuts: { count: 500, points: 500 },
      submissions: { count: 400, points: 400 },
      closings: { count: 2, points: 500 },
      totalPoints: 2600,
      percentOfGoal: 26.0,
      status: 'On Track',
      files: [
        {
          id: 'f1',
          borrowerName: 'James Whitaker',
          loanAmount: 425000,
          loanType: 'Conventional',
          stage: 'Closing',
          daysInStage: 2,
          isNotMoving: false,
        },
        {
          id: 'f2',
          borrowerName: 'Maria Garcia',
          loanAmount: 315000,
          loanType: 'FHA',
          stage: 'Submission',
          daysInStage: 12,
          isNotMoving: true,
        },
        {
          id: 'f3',
          borrowerName: 'Robert Fox',
          loanAmount: 550000,
          loanType: 'Conventional',
          stage: 'Doc Out',
          daysInStage: 4,
          isNotMoving: false,
        },
        {
          id: 'f4',
          borrowerName: 'Linda Smith',
          loanAmount: 280000,
          loanType: 'VA',
          stage: 'Credit Pull',
          daysInStage: 1,
          isNotMoving: false,
        },
        {
          id: 'f5',
          borrowerName: 'William Chen',
          loanAmount: 850000,
          loanType: 'Jumbo',
          stage: 'Closing',
          daysInStage: 5,
          isNotMoving: false,
        },
      ],
    },
    {
      id: '2',
      name: 'Marcus Johnson',
      initials: 'MJ',
      creditPulls: { count: 750, points: 1125 },
      docOuts: { count: 600, points: 600 },
      submissions: { count: 500, points: 500 },
      closings: { count: 3, points: 750 },
      totalPoints: 2975,
      percentOfGoal: 29.8,
      status: 'Needs Attention',
      files: [
        {
          id: 'f6',
          borrowerName: 'David Miller',
          loanAmount: 390000,
          loanType: 'Conventional',
          stage: 'Submission',
          daysInStage: 15,
          isNotMoving: true,
        },
        {
          id: 'f7',
          borrowerName: 'Sarah Wilson',
          loanAmount: 410000,
          loanType: 'FHA',
          stage: 'Doc Out',
          daysInStage: 18,
          isNotMoving: true,
        },
        {
          id: 'f8',
          borrowerName: 'Michael Brown',
          loanAmount: 320000,
          loanType: 'VA',
          stage: 'Credit Pull',
          daysInStage: 2,
          isNotMoving: false,
        },
        {
          id: 'f9',
          borrowerName: 'Emily Davis',
          loanAmount: 450000,
          loanType: 'Conventional',
          stage: 'Submission',
          daysInStage: 4,
          isNotMoving: false,
        },
      ],
    },
    {
      id: '3',
      name: 'Riley Park',
      initials: 'RP',
      creditPulls: { count: null, points: null },
      docOuts: { count: null, points: null },
      submissions: { count: null, points: null },
      closings: { count: null, points: null },
      totalPoints: null,
      percentOfGoal: null,
      status: 'New',
      files: [
        {
          id: 'f10',
          borrowerName: 'Thomas Anderson',
          loanAmount: 350000,
          loanType: 'Conventional',
          stage: 'Credit Pull',
          daysInStage: 1,
          isNotMoving: false,
        },
      ],
    },
  ],
  bonuses: {
    speedBonus: [
      { condition: 'Doc Out to Close within 14 Days', points: '+1,000' },
      { condition: 'Doc Out to Close within 21 Days', points: '+500' },
    ],
    earnedThisMonth: 1500,
  },
  deductions: {
    nonPto: {
      upTo15: 300,
      over15: 450,
    },
    fileNotMoving: 50,
  },
  compensationTiers: [
    {
      id: 'dev_lead',
      name: 'Developmental Team Lead',
      focus:
        'Train and develop new Loan Partners and Loan Officers the Mortgage Depot Way.',
      baseSalary: '$4,000 / MONTH',
      structure: [
        { units: '0 - 9 UNITS', bps: '35 BPS', extra: '' },
        { units: '10 UNITS', bps: '40 BPS', extra: '(+5 BPS)' },
        { units: '15 UNITS', bps: '45 BPS', extra: '(+10 BPS)' },
        { units: '25+ UNITS', bps: '50 BPS', extra: '(+15 BPS)' },
      ],
      goals: [
        'Develop, train and grow your team.',
        'Build strong producers.',
        'Create a pipeline of success.',
      ],
    },
    {
      id: 'team_lead',
      name: 'Team Lead',
      focus:
        'Keep and grow your team. Lead your producers to consistent success.',
      baseSalary: 'BASE',
      structure: [
        { units: '0 - 9 UNITS', bps: '35 BPS', extra: '' },
        { units: '10 UNITS', bps: '40 BPS', extra: '(+5 BPS)' },
        { units: '15 UNITS', bps: '45 BPS', extra: '(+10 BPS)' },
        { units: '25+ UNITS', bps: '50 BPS', extra: '(+15 BPS)' },
      ],
      goals: [
        'Retain your team.',
        'Drive production.',
        'Build a high-performing culture.',
      ],
    },
    {
      id: 'div_lead',
      name: 'Divisional Lead',
      focus:
        'Lead at a higher level. Grow your division. Build leaders and drive impact.',
      baseSalary: null,
      structure: [
        { units: '0 - 50 UNITS', bps: '10 BPS', extra: '' },
        { units: '51 - 60 UNITS', bps: '12 BPS', extra: '(+2 BPS)' },
        { units: '61 - 70 UNITS', bps: '14 BPS', extra: '(+2 BPS)' },
        { units: '71 - 80 UNITS', bps: '16 BPS', extra: '(+2 BPS)' },
        { units: '81 - 90 UNITS', bps: '18 BPS', extra: '(+2 BPS)' },
        { units: '91+ UNITS', bps: '20 BPS', extra: '(+2 BPS)' },
      ],
      goals: [
        'Drive division growth.',
        'Develop leaders.',
        'Create lasting impact.',
      ],
    },
  ],
}
